<template>
  <div id="container">
    <v-sheet v-if="$store.state['app-order'].basketItemCount > 0" color="chip">
      <div class="basket-wrap">
        <v-app-bar flat color="grey" height="80" style="flex: initial">
          <v-avatar color="secondary" size="48">
            <v-icon size="24" color="white">{{ icons.mdiBasket }}</v-icon>
          </v-avatar>
          <h2
            class="text-h5 ml-3 font-weight-medium"
            style="color: white !important; letter-spacing: 1px !important"
          >
            Sepet
          </h2>
          <v-spacer />
          <v-btn fab color="chip" depressed x-small @click="closeBasket()">
            <v-icon size="16">{{ icons.mdiClose }}</v-icon>
          </v-btn>
        </v-app-bar>

        <div v-if="!sepetLoading" class="flex-grow-1">
          <v-alert v-if="campaignMsg" type="info" color="warning" class="ma-2" dense outlined>
            <span class="text-caption">{{ campaignMsg }}</span>
          </v-alert>
          <v-data-table
            :headers="tableColumns"
            :items="shoppingCartItems.detail"
            :items-per-page="-1"
            sort-by="kid"
            fixed-header
            :height="tableHeight"
            style="min-height: 350px"
            mobile-breakpoint="100"
            hide-default-footer
          >
            <template #[`item.baslik`]="{ item }">
              <div class="d-flex align-center">
                <v-sheet
                  v-if="item.resim"
                  width="64"
                  height="64"
                  color="white"
                  class="d-flex align-center justify-center mt-1 rounded-lg overflow-hidden"
                  rounded
                >
                  <v-img class="rounded-lg" :src="$baseUrlAPI + '' + item.resim"></v-img>
                </v-sheet>

                <v-sheet
                  v-else
                  width="64"
                  height="64"
                  color="primary"
                  class="d-flex align-center justify-center mt-1 rounded-lg overflow-hidden"
                  rounded
                >
                  <v-icon color="white" size="24">
                    {{ icons.mdiCameraOff }}
                  </v-icon>
                </v-sheet>
                <div class="ms-3">
                  <div>
                    {{ item.prd_code }}
                  </div>
                  <div class="text-body-1 white--text">
                    {{ item.baslik.slice(14) }}
                  </div>
                </div>
              </div>
            </template>

            <template #[`item.siparis_miktari`]="{ item }">

              <CounterCartNew
                :uid="item.uid"
                :plant-id="item.selected_plant"
                :miktar="Number(item.qty)"
                :birim="item.birim || 'AD'"
                :birim-ritim="item.birimRitmi * 1"
                bg-color="transparent elevation-0"
                button-color="white"
                class="pt-1"
                :light="true"
                @refreshBasket="refreshBasket()"
                @deleteBasketItem="deleteBasketItem"
              />
            </template>
            <template #[`item.satirToplam`]="{ item }">
              <v-chip
                v-if="userData.role !== 'COMUSR'"
                label
                class="d-flex align-center justify-center text-overline"
              >
                {{ item.satirToplam | currency }}</v-chip
              >
            </template>
          </v-data-table>
        </div>
        <div v-if="!sepetLoading">
          <v-alert
            v-if="hasPendingMutabakat"
            :type="hasOverdueMutabakat ? 'error' : 'warning'"
            class="ma-2"
            dense
            outlined
          >
            <div class="d-flex align-center flex-wrap">
              <span class="text-caption mr-2">
                <template v-if="hasOverdueMutabakat">
                  Mutabakat onaylama süreniz dolduğu için sipariş veremezsiniz.
                  Lütfen "Mutabakat Onay Geçmişim" sayfasından onaylayın veya reddedin.
                </template>
                <template v-else>
                  Onayınızı bekleyen mutabakatınız bulunuyor. Süresi dolmadan onaylamanızı rica ederiz.
                </template>
              </span>
              <v-chip
                v-if="hasOverdueMutabakat"
                color="error"
                text-color="white"
                x-small
                class="font-weight-bold"
              >
                Süre Doldu
              </v-chip>
              <v-chip
                v-else-if="minRemainingMutabakatDays != null"
                :color="minRemainingMutabakatDays <= 0 ? 'error' : 'warning'"
                text-color="white"
                x-small
                class="font-weight-bold"
              >
                {{ minRemainingMutabakatDays <= 0 ? "Süre Doldu" : `${minRemainingMutabakatDays} Gün Kaldı` }}
              </v-chip>
            </div>
          </v-alert>

          <v-container fluid class="night">
            <v-row align="center" dense>
              <v-col cols="9" sm="8">
                <v-alert v-if="errorShow" type="error" class="ma-0" text outlined dense>
                  <span class="text-caption"
                    >Gün içerisinde 1 kere
                    {{ $route.params.type == "mamul" ? "Mamül" : "Sarf" }} siparişi
                    verebilirsiniz</span
                  >
                </v-alert>

                <v-btn
                  v-if="!errorShow && !hasOverdueMutabakat"
                  color="secondary"
                  block
                  class="text-capitalize"
                  style="height: 56px !important"
                  rounded
                  :loading="loading"
                  @click="basketStep2()"
                >
                  <div>
                    <div class="text-body-1">Sipariş Ver</div>
                    <div v-if="userData.role !== 'COMUSR'" class="text-caption text--secondary">
                      {{ toplamFiyat | currency }}
                    </div>
                  </div>
                </v-btn>
              </v-col>
              <v-col cols="3" sm="4" class="text-center">
                <v-btn
                  v-if="$vuetify.breakpoint.smAndUp"
                  rounded
                  color="white"
                  plain
                  block
                  class="text-capitalize"
                  @click="trashBasket()"
                >
                  <v-icon left>
                    {{ icons.mdiTrashCan }}
                  </v-icon>
                  Sepeti Temizle
                </v-btn>
                <v-btn v-else color="error" fab class="text-capitalize" @click="trashBasket()">
                  <v-icon>
                    {{ icons.mdiTrashCan }}
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </div>

        <v-sheet v-if="sepetLoading" color="grey" class="d-flex justify-center pa-6">
          <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
        </v-sheet>
      </div>
    </v-sheet>
    <v-sheet v-else flat tile height="100%">
      <div class="d-flex align-center justify-center" style="height: 100dvh">
        <div class="text-center">
          <v-icon color="primary" size="100">
            {{ icons.mdiBasketOff }}
          </v-icon>
          <div class="text-body-2 text-overline pt-1 pb-6">Sepetiniz Boş Lütfen Ürün Ekleyin</div>
          <v-btn depressed color="warning" rounded @click="closeBasket()"> Kapat </v-btn>
        </div>
      </div>
    </v-sheet>

    <v-dialog
      v-model="kurumsalDialog"
      max-width="450"
      class="elevation-0"
      scrollable
      persistent
      overlay-opacity="0.95"
      style="box-shadow: none"
    >
      <v-card rounded="xl" flat elevation="0">
        <v-card-title class="grey">
          <h4 class="text-body-1 text-sm-h6 font-weight-bold">Sipariş Bilgileri</h4>

          <v-spacer />

          <v-btn
            v-if="$vuetify.breakpoint.smAndUp"
            rounded
            small
            depressed
            color="chip"
            class="text-capitalize"
            @click="kurumsalSatisKapat()"
          >
            <v-icon left>{{ icons.mdiClose }}</v-icon>
            Kapat
          </v-btn>
          <v-icon v-else @click="kurumsalSatisKapat()" small>{{ icons.mdiClose }}</v-icon>
        </v-card-title>
        <v-card-subtitle
          v-if="!userData.role == 'COMUSR'"
          class="grey pb-2"
          style="font-size: 11px; letter-spacing: 0.5px"
        >
          <div class="ml-n1 text--disabled">* Aşağıda istenilen bilgiler zorunlu değildir.</div>
        </v-card-subtitle>
        <v-divider />
        <v-card-text
          ref="scrollableEl"
          class="pa-0 pa-sm-3 pb-0 pt-3"
          :style="
            userData.role == 'COMUSR'
              ? 'height: 340px'
              : userData.role == 'COMMAN' && catringAddressItems.length > 0
              ? 'height: 420px'
              : 'height: 260px'
          "
        >
          <v-container class="pb-0">
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col v-if="userData.role == 'COMMAN' && catringAddressItems.length > 0">
                  <v-autocomplete
                    label="Kullanıcı"
                    :items="catringAddressItems"
                    v-model="addressSelect"
                    :disabled="addressSelectDisabled"
                    :rules="[(v) => !!v || 'Item is required']"
                    required
                    rounded
                    filled
                    hide-details
                  />
                </v-col>
                <v-col
                  cols="12"
                  v-if="
                    userData.role == 'COMUSR' ||
                    (userData.role == 'COMMAN' && catringAddressItems.length > 0)
                  "
                >
                  <v-text-field
                    label="SAS No"
                    v-model="kurumsalData.poNumber"
                    :rules="[(v) => !!v || 'Item is required']"
                    required
                    rounded
                    filled
                    hide-details
                  />
                </v-col>
                <v-col cols="12">
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="kurumsalData.delirveryDate"
                        :value="kurumsalData.delirveryDate | moment('DD MMMM YYYY, dddd')"
                        label="Teslimat Tarihi"
                        rounded
                        filled
                        hide-details
                        readonly
                        clearable
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="kurumsalData.delirveryDate"
                      :weekday-format="weekdayFormat"
                      :show-current="false"
                      :first-day-of-week="1"
                      :min="minDeliveryDate"
                      :max="maxDeliveryDate"
                      @input="menu = false"
                      no-title
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    label="Not"
                    v-model="kurumsalData.buyer_note"
                    rounded
                    filled
                    hide-details
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="pa-0 pa-sm-3 pt-0">
          <v-container class="pt-0" style="z-index: 2">
            <v-row align="center">
              <v-col cols="12">
                <v-btn
                  color="secondary"
                  @click="kurumsalSatis()"
                  depressed
                  rounded
                  block
                  x-large
                  class="text-capitalize"
                >
                  Sipariş Tamamla
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { getVuetify, useRouter } from "@core/utils";
import { postData, addDays, formatDate, weekdayFormat } from "@utils";
import Pikaday from "pikaday";
import moment from "moment";
import "@netcz/vue-pikaday/dist/vue-pikaday.min.css";
import {
  mdiBank,
  mdiBasket,
  mdiBasketOff,
  mdiCamera,
  mdiCameraOff,
  mdiCalendar,
  mdiChevronDown,
  mdiChevronUp,
  mdiCircle,
  mdiClose,
  mdiContactlessPayment,
  mdiCreditCard,
  mdiMapMarker,
  mdiRefresh,
  mdiText,
  mdiTrashCan,
  mdiTruckFast,
} from "@mdi/js";
import VSnackbars from "v-snackbars";
import Vue from "vue";

// 3rd Party
import CounterCartNew from "@/components/CounterCartNew.vue";
import store from "@/store";
import orderStoreModule from "@/views/order/orderStoreModule";
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
import { useAppStore } from "@/stores/app";

export default {
  components: {
    CounterCartNew,

    // 3rd Party
    PerfectScrollbar,
    VSnackbars,
  },
  setup() {
    const appStore = useAppStore();
    const hasPendingMutabakat = computed(() => appStore.pendingMutabakat.length > 0);
    const hasOverdueMutabakat = computed(() =>
      appStore.pendingMutabakat.some((item) => item.must_approve)
    );
    const minRemainingMutabakatDays = computed(() => {
      const days = appStore.pendingMutabakat
        .map((item) => item.remaining_days)
        .filter((d) => d != null);
      return days.length ? Math.min(...days) : null;
    });
    const userData = JSON.parse(localStorage.getItem("userData"));
    const { route } = useRouter();
    const { router } = useRouter();
    const PRODUCT_APP_STORE_MODULE_NAME = "app-order";
    const shoppingCartItems = ref([]);
    const addressItems = ref([]);
    const mesafeliStatus = ref(false);
    const onBilgilendirmeStatus = ref(false);
    const errorShow = ref(false);
    const bankalar = ref([]);
    const cargoPrice = ref(0);
    const toplamOdenecekTutar = ref(0);
    const toplamOdenecekTutarHavale = ref(0);
    const bankItem = ref(0);
    const buyerNote = ref(null);
    const valid = ref(true);
    const sepetLoading = ref(true);
    const basketStep = ref(1);
    const loading = ref(false);
    const dialog = ref(false);
    const snackbar = ref([]);
    const form = ref(null);
    const addressSelect = ref();
    const perfectScrollbarOptions = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    };
    const responseStep2 = ref({});
    const onBilgilendirmeSozlesmesi = ref(null);
    const mesafeliSatisSozlesmesi = ref(null);
    const paymentErrorMsg = ref(null);
    const paymentError = ref(false);
    const scrollbar = ref();

    const desserts = ref([]);
    onMounted(() => {
      const $vuetify = getVuetify();
      if ($vuetify.breakpoint.smAndDown) scrollbar.value.destroy();
    });
    const tableColumns = [
      {
        text: "Miktar",
        value: "siparis_miktari",
        width: "120",
        align: "left",
        sortable: false,
      },
      {
        text: "Ürün",
        value: "baslik",
        align: "left py-2 min-width-500",
        sortable: false,
      },
    ];
    if (userData.role !== "COMUSR") {
      tableColumns.push({
        text: "Fiyat",
        value: "satirToplam",
        sortable: false,
      });
    }

    // Register module
    if (!store.hasModule(PRODUCT_APP_STORE_MODULE_NAME)) {
      store.registerModule(PRODUCT_APP_STORE_MODULE_NAME, orderStoreModule);
    }
    const catringAddressItems = ref([]);
    onMounted(() => {
      store.dispatch("app-order/fetchActiveBasketList").then((response) => {
        if (!response.error) {
          shoppingCartItems.value = response;
          sepetLoading.value = false;

          const orderType = {
            method: "getTodayOrderByMattype",
            mattype: shoppingCartItems.value.detail[0].mattype,
          };
          store.dispatch("postMethod", orderType).then((response) => {
            if (response.count > 0) {
              errorShow.value = true;
            } else {
              errorShow.value = false;
            }
          });
        } else {
          // console.table('hatalı =>', response)
        }
      });
      store
        .dispatch("app-order/fetchAddressList", {
          method: "getAddressListByUid",
        })
        .then((response) => {
          if (response.error === 0) {
            addressItems.value = response.response;

            if (addressItems.value.length > 2) {
              let result = response.response.filter((item) => {
                if (item.username) {
                  return item;
                }
              });

              catringAddressItems.value = result.map((item) => {
                return {
                  text: item.username,
                  value: item.id,
                  desc: item.address,
                };
              });
            }

            // errorShow.value = false

            //  console.table('başarılı =>', response)
          } else {
            // errorShow.value = true
          }
        });
      store
        .dispatch("app-order/fetchBankaList", {
          method: "getBankaTransferList",
        })
        .then((response) => {
          if (!response.error) {
            bankalar.value = response.detail;
          } else {
            console.table("hatalı =>", response);
          }
        });
    });

    const refreshBasket = () => {
      store.dispatch("app-order/fetchActiveBasketList").then((response) => {
        if (!response.error) {
          shoppingCartItems.value = response;
        } else {
          //   console.table('hatalı =>', response)
        }
      });
    };

    watch(
      () => store.getters["app-order/doneTodos"],
      () => {
        refreshBasket();
      }
    );

    const closeBasket = () => {
      store.commit("app/TOGGLE_BASKET_DRAWER", false);
    };
    const deleteBasketItem = ({ baslik, id, plant }) => {
      store.commit("app/TOGGLE_BASKET_DRAWER_TEMPORARY", false);
      Vue.swal({
        title: "Emin misin?",
        text: "Silme işlemini onaylayın",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Onaylıyorum",
      }).then((result) => {
        if (result.isConfirmed) {
          store.commit("app/TOGGLE_BASKET_DELETE", id);
          store.dispatch("app-order/fetchDeleteBasketItem", { id, plant }).then((response) => {
            if (response.error === 0) {
              snackbar.value.push({
                message: `${baslik} Ürünü Silindi`,
                color: "error",
                timeout: 3000,
              });
              store.dispatch("app-order/fetchActiveBasketList").then((response1) => {
                if (!response.error) {
                  shoppingCartItems.value = response1;
                  if (typeof response1.detail === "undefined") {
                    store.commit("app/TOGGLE_BASKET_DRAWER", false);
                  }

                  //     store.commit('app/TOGGLE_BASKET_DRAWER_TEMPORARY', true)
                } else {
                  store.commit("app/TOGGLE_BASKET_DRAWER", false);
                }
              });

              store.dispatch("refreshRiskLimit");
            } else {
              Vue.swal({
                title: "Hata",
                html: response.msg,
                icon: "error",
                background: "#FF4C51",
                timerProgressBar: true,
                showConfirmButton: false,
              });
            }
          });
        }
      });
    };

    const trashBasket = () => {
      Vue.swal({
        title: "Emin misin?",
        text: "Sepeti Temizlemek İstiyormusunuz",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Onaylıyorum",
      }).then((result) => {
        if (result.isConfirmed) {
          store.dispatch("app-order/fetchTrashBasket").then(() => {
            store.dispatch("app-order/fetchActiveBasketList").then((response) => {
              store.commit("app/TOGGLE_BASKET_DRAWER", false);
              Vue.swal({
                title: "Sepet Temizlendi",
                text: "İşlem başarılı",
                icon: "success",
                timer: 1500,
                background: "#56CA00",
                timerProgressBar: true,
                showConfirmButton: false,
              });
            });
          });

          store.dispatch("refreshRiskLimit");
        }
      });
    };
  /*   const observer = ref(null); */
    const addressSelectDisabled = ref(false);
    const basketStep2 = async () => {
      if (hasOverdueMutabakat.value) return;

      /* if (userData.role === "PLSYR") {
        const isValid = await observer.value.validate();

        if (!isValid) {
          return;
        }
      } */

      loading.value = true;
      store.dispatch("app-order/fetchGetOrderStep1Data").then((response) => {
        if (response.error == 0) {
          if (
            userData.role === "COMUSR" ||
            userData.role === "COMM" ||
            userData.role === "COMMAN"
          ) {
            addressItems.value.find((item) => {
              if (
                item.username === store.state.app.basketDrawerApproval.username &&
                item.username !== null &&
                store.state.app.basketDrawerApproval.username !== null
              ) {
                addressSelect.value = item.id;
                addressSelectDisabled.value = true;
              }
            });
            kurumsalData.value.poNumber = store.state.app.basketDrawerApproval.poNumber || "";
            kurumsalData.value.delirveryDate =
              store.state.app.basketDrawerApproval.delirveryDate || "";
            kurumsalData.value.buyer_note = store.state.app.basketDrawerApproval.buyer_note || "";
            kurumsalDialog.value = true;
          } else {
            store.commit("app/TOGGLE_BASKET_DRAWER_APPROVAL", {
              username: null,
              delirveryDate: null,
              buyer_note: null,
              poNumber: null,
            });
            basketStep3();
          }
        } else {
          Vue.swal({
            title: "Hata",
            html: response.msg,
            icon: "error",

            background: "#FF4C51",
            timerProgressBar: true,
            showConfirmButton: false,
          });
          loading.value = false;
        }
      });
    };

    const orderDate = ref(null);
    const delirveryDate = ref(null);
    const orderRefNo = ref(null);
    const date1 = ref(null);
    const date2 = ref(null);

    const basketStep3 = async () => {
      loading.value = true;

      const payload = {
        deliveryAddr: addressSelect.value || addressItems.value[0]?.id || 1,
        invoiceAddr: addressSelect.value || addressItems.value[0]?.id || 1,
        cargo: 11,
        orderRefNo: orderRefNo.value,
        buyer_note: kurumsalData.value.buyer_note,
        poNumber: kurumsalData.value.poNumber,
        orderDate: date1.value || orderDate.value,
        delirveryDate: kurumsalData.value.delirveryDate || date2.value,
      };

      store.dispatch("app-order/fetchMakeOrderStep1", payload).then((result) => {
        if (result.error === 0) {
          store.dispatch("app-order/fetchGetOrderStep2Data").then((response) => {
            responseStep2.value = response;
            const payloadPay = {
              method: "makeOrderStep2",
              paymentType: 2,
              banka: bankalar.value[bankItem.value]?.id,
            };

            store.dispatch("app-order/fetchMakeOrderStep2", payloadPay).then(() => {
              store.dispatch("app-order/fetchGetOrderStep3Data").then((response) => {
                mesafeliSatisSozlesmesi.value = response.mesafeliSatisSozlesmesi;
                onBilgilendirmeSozlesmesi.value = response.onBilgilendirmeSozlesmesi;
                const container = document.querySelector("#container");

                container.scrollTop = 0;
                cargoPrice.value = responseStep2.value.detail?.ordering?.totalCargoAmount || 0;

                toplamOdenecekTutar.value = responseStep2.value.detail?.ordering?.totalAmount || 0;
                toplamOdenecekTutarHavale.value =
                  responseStep2.value.detail?.ordering?.totalAmount || 0;

                store.dispatch("app-order/fetchMakeOrderStep3").then(async (response) => {
                  if (response.error === 0) {
                    store.commit("app/TOGGLE_BASKET_DRAWER", false);

                    store.dispatch("app-order/fetchGetOrderStep4Data").then((response) => {
                      if (response.detail.error === 1) {
                        // router.push({ name: 'dashboard' })
                      } else {
                        Vue.swal({
                          title: "İşlem Başarılı",
                          text: "Kaytı işleminiz gerçekleşmiştir.",
                          icon: "success",
                          width: 320,
                          timer: 2500,
                          background: "#56CA00",
                          timerProgressBar: true,
                          showConfirmButton: false,
                          showCloseButton: false,
                        });
                        store.dispatch("app-order/fetchBasketItemCount");
                        router.push({ name: "order-tracking" });

                        // detail.value = response.detail
                      }
                    });
                  } else {
                    loading.value = false;
                    paymentErrorMsg.value = response.msg;
                    paymentError.value = true;
                    Vue.swal({
                      title: "Hata",
                      html: response.msg,
                      icon: "error",
                      background: "#FF4C51",
                      timerProgressBar: true,
                      showConfirmButton: false,
                    });
                  }
                });
              });
            });
          });
        } else {
          loading.value = false;
          Vue.swal({
            title: "Hata",
            html: result.msg,
            icon: "error",

            background: "#FF4C51",
            timerProgressBar: true,
            showConfirmButton: false,
          });
        }
      });
    };
    const baslikSplit = (val, index) => {
      let result;
      if (val.split("(").length > 1) {
        if (index === 0) {
          result = val.split("(")[index].slice(0, -1);
        } else {
          result = `(${val.split("(")[index].slice(0, -1)})`;
        }
      } else if (index === 0) {
        result = val;
      }

      return result;
    };

    const kurumsalDialog = ref(false);

    const menu = ref(false);
    const minDeliveryDate = ref(formatDate(addDays(0)));
    const maxDeliveryDate = ref(formatDate(addDays(30)));
    const kurumsalData = ref({
      delirveryDate: null,
      poNumber: null,
      buyer_note: null,
    });
    const kurumsalSatisKapat = () => {
      kurumsalDialog.value = false;
      kurumsalData.value.poNumber = null;
      kurumsalData.value.delirveryDate = null;
      kurumsalData.value.buyer_note = null;
      addressSelect.value = "";
      addressSelectDisabled.value = false;

      store.commit("app/TOGGLE_BASKET_DRAWER_APPROVAL", {
        username: null,
        delirveryDate: null,
        buyer_note: null,
        poNumber: null,
      });

      loading.value = false;
    };
    const kurumsalSatis = () => {
      if (!form.value.validate()) {
        return;
      }
      if (userData.role === "COMMAN") {
        basketStep3();
      } else {
        const payload = {
          deliveryAddr: addressSelect.value || addressItems.value[0]?.id || 1,
          invoiceAddr: addressSelect.value || addressItems.value[0]?.id || 1,
          cargo: 11,
          buyer_note: kurumsalData.value.buyer_note,
          poNumber: kurumsalData.value.poNumber,
          orderDate: date1.value || orderDate.value,
          delirveryDate: kurumsalData.value.delirveryDate,
        };
        postData({
          method: "saveBasketForSubcust",
          ...payload,
        }).then((response) => {
          if (response.error === 0) {
            store.commit("app/TOGGLE_BASKET_DRAWER", false);
            loading.value = false;
            store.dispatch("app-order/fetchBasketItemCount");
            Vue.swal({
              title: "Sipariş Durum",
              text: response.msg,
              icon: "success",
              timer: 1500,
              background: "#56CA00",
              timerProgressBar: true,
              showConfirmButton: false,
            });
          } else {
            loading.value = false;
            Vue.swal({
              title: "Hata",
              html: response.msg,
              icon: "error",

              background: "#FF4C51",
              timerProgressBar: true,
              showConfirmButton: false,
            });
          }
        });
      }
    };
    return {
      appStore,
      hasPendingMutabakat,
      hasOverdueMutabakat,
      minRemainingMutabakatDays,
      catringAddressItems,
      menu,
      kurumsalSatisKapat,
      kurumsalDialog,
      minDeliveryDate,
      maxDeliveryDate,
      weekdayFormat,
      kurumsalData,
      kurumsalSatis,
      baslikSplit,
      delirveryDate,
      orderDate,
      date1,
      date2,
      paymentErrorMsg,
      paymentError,
      desserts,
      userData,
      mesafeliStatus,
      onBilgilendirmeStatus,
      form,
      sepetLoading,
      dialog,
      basketStep2,
      cargoPrice,
      buyerNote,
      basketStep3,
      bankItem,
      perfectScrollbarOptions,
      shoppingCartItems,
      addressItems,
      errorShow,
      deleteBasketItem,
      mesafeliSatisSozlesmesi,
      onBilgilendirmeSozlesmesi,
      basketStep,
      closeBasket,
      refreshBasket,
      addressSelect,
      addressSelectDisabled,
      toplamOdenecekTutar,
      toplamOdenecekTutarHavale,
      tableColumns,
      loading,
      bankalar,
      valid,
      trashBasket,
      snackbar,
      scrollbar,
   /*    observer, */
      orderRefNo,
      icons: {
        mdiText,
        mdiChevronDown,
        mdiChevronUp,
        mdiClose,
        mdiTruckFast,
        mdiTrashCan,
        mdiContactlessPayment,
        mdiRefresh,
        mdiBasket,
        mdiCalendar,
        mdiCreditCard,
        mdiBank,
        mdiMapMarker,
        mdiBasketOff,
        mdiCamera,
        mdiCameraOff,
        mdiCircle,
      },
    };
  },
  data: () => ({
    menu1: false,
    menu2: false,
  }),
  computed: {
    campaignMsg() {
      const raw = this.shoppingCartItems?.campaign_msg;
      if (typeof raw !== "string") return "";
      return raw.trim();
    },
    tableColspan() {
      return Array.isArray(this.tableColumns) && this.tableColumns.length > 0 ? this.tableColumns.length : 1;
    },
    tableHeight() {
      // Banner görünürse tablo yüksekliğini biraz düşürüp taşmayı azaltıyoruz.
      return this.campaignMsg ? "calc(100dvh - 220px)" : "calc(100dvh - 160px)";
    },
    shoppingDeposit() {
      return this.shoppingCartItems.detail.filter((item) => item.readOnly);
    },
    satirToplamFiyat() {
      return this.shoppingCartItems?.summary?.satirToplamFiyat;
    },
    satirToplamKDV() {
      return this.shoppingCartItems?.summary?.satirToplamKDV;
    },
    toplamBrutFiyat() {
      return this.shoppingCartItems?.summary?.toplamBrutFiyat;
    },
    toplamFiyat() {
      return this.shoppingCartItems?.summary?.toplamFiyat;
    },
    toplamIndirimTutari() {
      return this.shoppingCartItems?.summary?.toplamIndirimTutari;
    },
    urunSayisi() {
      return this.shoppingCartItems?.summary?.urunSayisi;
    },
    urunSayisiKonya() {
      let result = [];
      result = this.shoppingCartItems.detail.filter((item) => {
        if (item.selected_plant === "02") {
          return item;
        }
      });

      return result.length;
    },
    urunSayisiTekirdag() {
      let result = [];
      result = this.shoppingCartItems.detail.filter((item) => {
        if (item.selected_plant === "01") {
          return item;
        }
      });

      return result.length;
    },

    toplamPaketSayisi() {
      return this.shoppingCartItems?.summary?.toplamPaketSayisi;
    },

    paketSayisiKonya() {
      let result = [];
      result = this.shoppingCartItems.detail.filter((item) => {
        if (item.selected_plant === "02") {
          return item;
        }
      });

      return result.reduce((sum, item) => sum + item.paketSayisi, 0);
    },

    paketSayisiTekirdag() {
      let result = [];
      result = this.shoppingCartItems.detail.filter((item) => {
        if (item.selected_plant === "01") {
          return item;
        }
      });

      return result.reduce((sum, item) => sum + item.paketSayisi, 0);
    },

    address_title() {
      let result = null;
      if (this.addressItems.length > 0) {
        result = this.addressItems[this.addressSelect]?.address_title;
      }

      return result;
    },
  },
  watch: {
    date1(val) {
      this.orderDate = this.formatDate(this.date1);
    },
    date2(val) {
      this.delirveryDate = this.formatDate(this.date2);
    },
  },
  mounted() {
    this.orderDate = this.formatDate(new Date().toISOString().split("T")[0]);
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");

      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");

      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/style.scss";
// Set Perfect Scrollbar Container Height
.vertical-shopping-cart-container {
  height: 100%;
  .ps-nav-menu-items {
    height: calc(100% - 35px) !important;
    @media #{map-get($display-breakpoints, 'md-and-up')} {
      height: calc(100%) !important;
    }
  }
}

.v-application--is-ltr .theme--dark.v-stepper--vertical .v-stepper__content:not(:last-child) {
  border-left: 0 !important;
}
.v-application--is-ltr .v-stepper--vertical .v-stepper__content {
  margin: -8px -36px -16px 0px !important;
}
.vertical-align-basline {
  vertical-align: baseline !important;
}
.basket-wrap {
  display: flex;
  flex-direction: column;
  height: 100dvh;
}
.v-dialog--scrollable {
  box-shadow: none !important;
}
</style>
